<template>
  <div>
    <div class="inputWrapper flex">
      <div class="inputTitle" style="line-height: 28px!important;">验证码</div>
      <div class="inputBox flex1">
        <input
          style="line-height: 28px!important;"
          v-model="params.validateCode"
        />
      </div>
      <div class="codeButton" :class="{ disabled: isDisable }" @click="getCode">
        {{ getMobileCodeText() }}
      </div>
    </div>
    <div class="saveButton" v-if="load === true">
      <img src="../../assets/loading.gif" />
    </div>
    <div class="saveButton" v-else @click="unbind">解绑</div>
  </div>
</template>

<script>
import { getUnBindCode, unBindConfirm } from "../../api/bank";

export default {
  name: "unbind",
  data() {
    return {
      wait_timer: false,
      isDisable: false,
      params: {
        bankId: "",
        validateCode: ""
      },
      load: false
    };
  },
  mounted() {
    this.params.bankId = parseInt(this.$route.params.id);
  },
  methods: {
    getCode() {
      let that = this;
      that.wait_timer = 59;
      that.isDisable = true;
      let timer_interval = setInterval(function() {
        if (that.wait_timer > 0) {
          that.wait_timer--;
        } else {
          that.isDisable = false;
          clearInterval(timer_interval);
        }
      }, 1000);

      getUnBindCode({
        bankId: this.$route.params.id
      })
        .then(() => {})
        .catch(err => {
          this.$showError(err);
        });
    },

    getMobileCodeText: function() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }

      if (this.wait_timer === 0) {
        return "重新获取";
      }

      if (this.wait_timer === false) {
        return "获取验证码";
      }
    },

    unbind: function() {
      this.load = true;
      unBindConfirm(this.params)
        .then(() => {
          this.load = false;
          this.$showMessage("解绑成功");
          this.$router.replace("/bankCard/bankCard");
        })
        .catch(err => {
          this.load = false;
          this.$showError(err);
        });
    }
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
}

.inputWrapper {
  background: #fff;
  text-align: left;
  overflow: hidden;
  padding: 36px 30px;
  border-bottom: 1px solid #e8e8e8;
}

.inputTitle {
  width: 120px;
  font-size: 14px;
  line-height: 28px;
  color: #474747;
}

.inputBox {
  font-size: 14px;
  line-height: 28px;
  color: #262626;
}

.inputBox input {
  line-height: 14px;
  width: 100%;
  text-align: left;
  border: none;
}

.codeButton {
  width: 180px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  background: #007bec;
  color: #fff;
  border-radius: 28px;
  font-size: 14px;
  margin-left: 20px;
}

.saveButton {
  margin: 50px 30px 30px 30px;
  text-align: center;
  letter-spacing: 10px;
  font-size: 14px;
  color: #fff;
  height: 84px;
  line-height: 84px;
  background: #007bec;
  border-radius: 10px;
}

.saveButton img {
  width: 32px;
  height: 32px;
  line-height: 84px;
}
</style>
